module.exports = __webpack_public_path__ + "static/media/dinner.191cfcc5.jpg";